<template>
    <article v-if="form.hasErrors()" class="message is-danger">
        <div class="message-body">
            <div class="message-content">
                <fa-icon icon="exclamation-triangle" />
                <slot>Something went wrong, please try again.</slot>
            </div>
            <button
                v-if="!hideClose"
                class="delete is-pulled-right"
                @click.prevent="close"
            ></button>
        </div>
    </article>
</template>

<script>
export default {
    props: {
        form: { type: Object, required: true },
        hideClose: { type: Boolean, default: false },
    },

    methods: {
        close() {
            this.$el.parentNode.removeChild(this.$el);
        },
    },
};
</script>
